import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { TARIFFICATOR_BILLING_PRODUCT_ID } from '@/shared/lib/analytics/offer';
import { getOfferTitle } from '@/shared/lib/analytics';

interface SubscriptionOfferAnalyticsParams {
    buttonText: string;
    offer: Offer | null;
    entityType?: string;
}

interface SubscriptionOfferAnalytics {
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
}

export function createSubscriptionOfferAnalytics(
    eventSender: AnalyticsSender,
    { buttonText, entityType, offer }: SubscriptionOfferAnalyticsParams
): SubscriptionOfferAnalytics {
    const tariffName = offer?.catalogCompositeOffer?.tariffOffer?.name;
    const optionName = offer?.catalogCompositeOffer?.optionOffers?.[0]?.name;

    return {
        showed() {
            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                show: offer?.offerPositionsData ?? {},
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
            });
        },
        navigated() {
            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                click: offer?.offerPositionsData ?? {},
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: offer?.billingProductIds ?? '',
            });
        },
    };
}
